const LISTE_ECRITURE_COMPTABLE = {
  title: 'Ecritures Comptables',
  tab: {
    compteComptable: 'Compte comptable',
    dateComptable: 'Date comptable',
    libelleLigneEcriture: 'Libellé ligne d\'écriture',
    libelleEcriture: 'Libellé d\'écriture',
    debit: 'Débit',
    credit: 'Crédit',
    codeJournal: 'Code Journal',
    typeEcriture: 'Type écriture',
    dateDebut: 'Date début',
    dateFin: 'Date de fin',
    compteAuxiliaire: 'Compte Auxiliaire',
    reference: 'Référence de la pièce',
    etat: 'Etat',
    agence: 'Agence',
    lot: 'Lot',
  },
  filtre: {
    tiers: 'Tiers',
    dateComptable: 'Date comptable',
    journaux: 'Journal(aux)',
    comptesComptables: 'Compte(s) comptable',
    agence: 'Agence',
    valide: 'Valide',
    agences: 'Agence(s)',
    typeEcriture: 'Type d\'écriture',
  },
};

export default LISTE_ECRITURE_COMPTABLE;
